/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/no-schedule-1218387': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.66 7H15v1a1 1 0 002 0V7h1a1 1 0 011 1v3h-1.34a1 1 0 000 2H19v1.34a1 1 0 102 0V8a3 3 0 00-3-3h-1V4a1 1 0 00-2 0v1h-3.34a1 1 0 000 2zm10.05 13.29l-1.6-1.6-16.4-16.4a1 1 0 00-1.42 1.42l1.91 1.9A3 3 0 003 8v10a3 3 0 003 3h12a3 3 0 001.29-.3l1 1a1 1 0 001.42 0 1 1 0 000-1.41zM5 8a1 1 0 01.66-.93L9.59 11H5zm1 11a1 1 0 01-1-1v-5h6.59l6 6z"/>'
  }
})
